import { FC } from 'react'

import { DivisorLineFormProps } from './types'

const DivisorLineForm: FC<DivisorLineFormProps> = ({ text }) => {
  return (
    <div className="flex w-full justify-center items-center relative my-4">
      <span className="flex flex-1 h-1 border-b-grayscale-100 border-dashed border-b ml-12 mr-6" />
      <span className="min-w-[151px] text-center px-2 py-1 bg-grayscale-100 rounded-md prose-body text-primary-900 font-semibold">
        {text}
      </span>
      <span className="flex flex-1 h-1 border-b-grayscale-100 border-dashed border-b ml-6 mr-12" />
    </div>
  )
}

export default DivisorLineForm
